import React, { Component } from 'react';
import styles from './styles';

import { AxlInput, AxlPanel, AxlButton } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";

@inject('deliveryStore')
@observer
class ShipmentDropoffDispatchForm extends Component {
  save = (e) => {
    const {deliveryStore, shipment, closeForm} = this.props;
    deliveryStore.updateShipmentDropoffLocation(shipment, () => {
      closeForm()
    });
  };

  render() {
    const { deliveryStore, shipment } = this.props;
    const { shipmentDropoffForm } = deliveryStore;

    return <div style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Dispatch Override`}</div>
      <AxlPanel>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <AxlPanel.Row align={`center`}>
              <AxlPanel.Col>
                <div style={styles.GroupTitle}>{`Dropoff Access Code`}</div>
                <div style={styles.Field}><AxlInput value={shipmentDropoffForm.getField('dropoff_access_code', '')} onChange={shipmentDropoffForm.handlerInput} placeholder={`e.g: #1234`} name={`dropoff_access_code`} type={`text`} fluid /></div>
                <div style={styles.GroupTitle}>{`Dropoff Additional Instruction`}</div>
                <div style={styles.Field}><AxlInput value={shipmentDropoffForm.getField('dropoff_additional_instruction', '')} onChange={shipmentDropoffForm.handlerInput} placeholder={`e.g: Baby inside, do not ring the bell`} name={`dropoff_additional_instruction`} type={`text`} fluid /></div>
              </AxlPanel.Col>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`flex-end`}>
              <div style={{...styles.Field, ...styles.FieldButton}}><AxlButton compact bg={`gray`} onClick={this.props.closeForm} style={styles.buttonControl}>{`Cancel`}</AxlButton></div>
              <div style={{...styles.Field, ...styles.FieldButton}}><AxlButton compact bg={`pink`} onClick={this.save} style={styles.buttonControl}>{`Save`}</AxlButton></div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </div>
  }
}

export default ShipmentDropoffDispatchForm;